'use strict';

wbApp.controller('ActivityReconciliationAttendanceCtrl', ['$scope', '$modal', 'activityReconciliationSvc',
function ($scope, $modal, activityReconciliationSvc) {

    $scope.attendance = [];

    $scope.semesterID = null;
    $scope.activityID = null;
    $scope.studentID = null;

    var isActive = false;
    var loaded = false;

    function reloadData() {
        if ($scope.activityID && $scope.studentID) {
            $scope.attendance = activityReconciliationSvc.getStudentsAttendanceByActivity(
                $scope.semesterID,
                $scope.activityID,
                $scope.studentID);
            loaded = true;
        } else {
            $scope.attendance = [];
        }
    }

    $scope.$on('activeTabChanged', function (e, data) {
        if (data.activeTab === 1) {
            if (!isActive) {
                isActive = true;
                if (!loaded) {
                    reloadData();
                }
            }
        } else {
            isActive = false;
        }
    });

    $scope.$on('activityStudentSelectionChanged', function (e, data) {
        if (data.studentID != $scope.studentID ||
            data.activityID != $scope.activityID ||
            data.reasonCode == 'activityReconciliationChanged') {
            $scope.semesterID = data.semesterID;
            $scope.activityID = data.activityID;
            $scope.studentID = data.studentID;

            if (isActive) {
                reloadData();
            } else {
                loaded = false;
            }
        } else {
            $scope.attendance.length = 0;
        }
    });

    $scope.acivityReconciliationAttendanceFilterOptions = {
        filterText: ""
    };

    $scope.acivityReconciliationAttendanceGridOptions = {
        sortInfo: { fields: ['date'], directions: ['asc'] },
        columnDefs: [
            { field: 'date', cellFilter: "date:'EEE d. M. yy'", displayName: "TXT_DAY", width: '100px' },
            { field: 'firstPeriod', displayName: "TXT_AM", width: '100px' },
            { field: 'firstSnack', displayName: "TXT_SNACK", width: '70px' },
            { field: 'lunch', displayName: "TXT_LUNCH", width: '70px' },
            { field: 'firstPeriodAttendanceStatus', cellFilter: 'translate', displayName: "TXT_COL_ATTENDANCE_STATUS", width: '120px' },
            { field: 'firstPeriodAttendanceType', cellFilter: 'translate', displayName: "TXT_COL_ATTENDANCE_TYPE", width: '120px' },
            { field: 'secondPeriod', displayName: "TXT_PM", width: '100px' },
            { field: 'secondSnack', displayName: "TXT_SNACK", width: '70px' },
            { field: 'secondPeriodAttendanceStatus', cellFilter: 'translate', displayName: "TXT_COL_ATTENDANCE_STATUS", width: '120px' },
            { field: 'secondPeriodAttendanceType', cellFilter: 'translate', displayName: "TXT_COL_ATTENDANCE_TYPE", width: '120px' },
            { field: 'notes', displayName: "TXT_LBL_NOTE" }
        ],
        noCommandColumn: true,
        disabledField: 'reconciled'
    };


}]);